import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  Popper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserFromToken } from "../../utilities/authUtils";

function Header() {
  const navigate = useNavigate();
  const [openPopper, setOpenPopper] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper((previousOpen) => !previousOpen);
  };

  const handlePopperClose = () => {
    setOpenPopper(false);
  };

  const handleLogout = () => {
    const currentDomain = window.location.hostname;
    const cookieOpts = {
      domain: currentDomain
        ? currentDomain
        : process.env.REACT_APP_COOKIES_DOMAIN,
      path: "/",
    };
    Cookies.remove("jwtToken", cookieOpts);
    Cookies.remove("userEmail", cookieOpts);
    Cookies.remove("access", cookieOpts);
    navigate("/");
    handlePopperClose();
  };

  const canBeOpen = openPopper && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;
  const user = getUserFromToken();
  const initials = (user?.FirstName?.[0] || "A").toUpperCase();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderBottom: "1px solid var(--ax-border)",
        background: "var(--ax-surface)",
        px: 3,
        py: 1.5,
        boxSizing: "border-box",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "9px",
            background: "var(--ax-blue)",
            display: "grid",
            placeItems: "center",
            color: "#fff",
            fontFamily: "var(--ax-font-heading)",
            fontWeight: 600,
            fontSize: "0.92rem",
            letterSpacing: "-0.02em",
          }}
        >
          A
        </Box>
        <Box>
          <Typography
            sx={{
              fontFamily: "var(--ax-font-heading)",
              fontWeight: 600,
              fontSize: "0.96rem",
              color: "var(--ax-ink)",
              letterSpacing: "-0.015em",
              lineHeight: 1,
            }}
          >
            Aapmor
          </Typography>
          <Typography
            sx={{
              fontSize: "0.66rem",
              color: "var(--ax-ink-3)",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              fontWeight: 500,
              mt: "2px",
            }}
          >
            SSO Platform
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" gap={2} alignItems="center">
        <Box>
          <Tooltip title={user?.Email || user?.FirstName || "Account"}>
            <Avatar
              src={user?.profileImage || ""}
              onClick={handleClick}
              sx={{
                cursor: "pointer",
                bgcolor: "var(--ax-blue)",
                width: 34,
                height: 34,
                fontSize: "0.78rem",
                fontWeight: 600,
                borderRadius: "10px",
              }}
            >
              {initials}
            </Avatar>
          </Tooltip>
          <Popper id={id} open={openPopper} anchorEl={anchorEl}>
            <Box>
              <Menu
                anchorEl={anchorEl}
                open={openPopper}
                onClose={handlePopperClose}
                onClick={handlePopperClose}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 220,
                    borderRadius: "12px",
                    border: "1px solid var(--ax-border)",
                    boxShadow: "var(--ax-shadow)",
                  },
                }}
              >
                <MenuItem disabled sx={{ opacity: "1 !important", py: 1.25 }}>
                  <Stack direction="row" alignItems="center" gap={1.5}>
                    <Avatar
                      src={user?.profileImage}
                      sx={{
                        width: 32,
                        height: 32,
                        bgcolor: "var(--ax-blue)",
                        fontSize: "0.74rem",
                        fontWeight: 600,
                        borderRadius: "8px",
                      }}
                    >
                      {initials}
                    </Avatar>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "0.86rem",
                          fontWeight: 600,
                          color: "var(--ax-ink)",
                        }}
                      >
                        {user?.FirstName || "Admin"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.74rem",
                          color: "var(--ax-ink-2)",
                        }}
                      >
                        {user?.Email || ""}
                      </Typography>
                    </Box>
                  </Stack>
                </MenuItem>
                <MenuItem
                  disabled
                  sx={{ fontSize: "0.84rem", color: "var(--ax-ink-2)" }}
                >
                  Account Settings
                </MenuItem>
                <MenuItem
                  onClick={handleLogout}
                  sx={{ fontSize: "0.84rem", color: "var(--ax-ink)" }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Popper>
        </Box>
      </Stack>
    </Box>
  );
}

export default Header;
